import { formatDateDottedFromString } from 'shared/utils/formatting';

type FormatShiftDateTimeLinesArgs = {
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
};

export const formatShiftDateTimeLines = ({
  startDate,
  endDate,
  startTime,
  endTime,
}: FormatShiftDateTimeLinesArgs): string[] => {
  const formattedStartDate = formatDateDottedFromString(startDate);
  const formattedEndDate = formatDateDottedFromString(endDate);
  const timeRange = `${startTime} - ${endTime}`;

  if (formattedStartDate === formattedEndDate) {
    return [`${formattedStartDate} ${timeRange}`];
  }

  return [`${formattedStartDate} - ${formattedEndDate},`, timeRange];
};
